<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <component v-if="component" :is="component" :data="data"></component>
  </v-dialog>
</template>

<script lang="ts">
import { EventBus, Events } from '@/event-bus';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DialogComponent extends Vue {
  /** Used to toggle the dialog. */
  show = false;

  /** Used to determine which component will be rendered in the dialog. */
  component: string | any = null;

  /** The component's data. */
  data: any = null;

  mounted() {
    // Subscribe to events.
    EventBus.$on(Events.Dialog.OpenDialogEvent, this.open);
    EventBus.$on(Events.Dialog.CloseDialogEvent, this.close);
  }

  /**
   * Opens the dialog.
   * @param component The component options object or name to be rendered in the dialog.
   * @param data An optional data object for the component.
   */
  open(component: string | any, data?: any): void {
    if (!['string', 'function', 'object'].includes(typeof component)) {
      throw new Error('Open dialoag: Invalid component options object or name.');
    }

    this.component = component;
    this.data = data;
    this.show = true;
  }

  /**
   * Closes the dialog.
   */
  close(): void {
    this.show = false;
  }
}
</script>
